import { put, select, take } from 'redux-saga/effects';
import * as actions from '../actions';
import * as selectors from '../selectors';

export function* getUserOrWait() {
  let user = yield select(selectors.users.getUser);

  if (!user?.id) {
    take(actions.user.loginSuccess);
    return yield select(selectors.users.getUser);
  }
  return user;
}

export function* getFirmsOrWait() {
  let firms = yield select(selectors.firms.firmOptions);
  console.log('getFirmsorWait', { firms });

  // wait until actions.firm.getFirmsForLookupSuccess is called
  if (!firms?.length) {
    const action = take(actions.firm.getFirmsForLookupSuccess);
    console.log({ action });
    return yield select(selectors.firms.firmsForUserCompany);
  }

  return firms;
}

export function* waitFor(selector) {
  console.log('waitFor', { selector });
  const value = yield select(selector);
  if (value && value.length) return; // (1)

  while (true) {
    yield take('*'); // (1a)
    const value = yield select(selector);
    if (value && value.length) return; // (1)
  }
}
